import React, { useState, useEffect } from "react";
import { Alert, Container, Modal, Snackbar } from "@mui/material";
import axios from "axios";
import housestyles from "./../Hostels/houses.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loadingspinner from "../Components/loading";
import { FetchSinglebizurl } from "../Utils/urls";
import { isDesktop, isMobile } from "react-device-detect";
import Universalheader from "../Headers/universalheader";
import SignIn from "../Common/login";
import Sharepopup from "../Components/sharepopup";
import { FaFacebookMessenger, FaPhoneAlt, FaShareSquare, FaShoppingCart, FaStarOfLife } from "react-icons/fa";
import { primarycolor } from "../Utils/colors";
import MapComponent from "../Hostels/mapcomponent";
import { getsessioncart, getsessionuser, setsessioncart, setsessionhouse } from "../Utils/sessions";
import Shuffle from "../Utils/shuffle";

const Viewsingleservice = ({ onrefresh }) => {
    const user = getsessionuser();
    const cart = getsessioncart()

    const location = useLocation();
    const navigate = useNavigate();
    const email = location.state.item.email
    const [cartarray, setcartarray] = useState([cart]);
    const [nothing, setnothing] = useState(false);


    const [item, setitem] = useState(location.state.item);

    //basics
    const [loading, setloading] = useState(true);
    const [error, seterror] = useState('');
    //shows
    const [showloginpopup, setshowloginpopup] = useState(false);
    const [showloginpopup2, setshowloginpopup2] = useState(false);
    const [sharepopup, setsharepopup] = useState(false);
    const [showimage, setshowimage] = useState(false);

    //objects
    const [defaulturl, setdefaulturl] = useState('');

    //arrays
    const [business, setbusiness] = useState('');
    const [catalogue, setcatalogue] = useState([]);




    useEffect(() => {
        fetchbusiness()
    }, []);

    const fetchbusiness = () => {
        setloading(true)
        axios.post(FetchSinglebizurl, {
            email: email
        }).then(function (response) {
            setloading(false)
            if (!response.data.message) {
                setbusiness(response.data)
                setcatalogue(response.data.catalogue)
            } else {
                seterror(response.data.message);
            }
            // 
        }).catch(function (error) {
            setloading(false)
            seterror("Sorry there was an error try again later")
            //if(error.response.status === 401 || error.response.status === 400){}

        });
    }


    const url = 'https://eazistey.co.ke/nav/viewsingleservice/' + email

    //add to acart
    const addtocart = () => {
        const itemtopush = {
            itemname: item.name,
            itemedescription: item.description,
            itememail: item.email,
            itemprice: item.price,
            itemurl: item.url,
            itemquantity: 1,
            phone: business?.phone,
            email: business?.email,
            username: business?.username,
            ownerurl: business?.url,
            status: business?.status
        }
        if (user) {
            if (cartarray?.length > 0) {
                const items = []
                cartarray.forEach(element => {//check if item exixts in cart
                    if (element?.itemname == item.name) {
                        items.push(element)
                    }
                });
                if (items.length > 0) {
                    seterror("item already in cart")
                } else if (cartarray[0].itememail !== email) {
                    seterror("You can only checkout items from one business")
                } else {
                    onrefresh()
                    cartarray.push(itemtopush)
                    setsessioncart(cartarray)
                    setnothing(!nothing)
                }

            } else {
                onrefresh()
                setcartarray([itemtopush])
                setsessioncart([itemtopush])
                setnothing(!nothing)
            }
        } else {
            setshowloginpopup(true)
        }

    }

    //redirect user after success login
    const onsuccesslogin = () => {
        setshowloginpopup(false)
        onrefresh()
        const itemtopush = {
            itemname: item.name,
            itemedescription: item.description,
            itememail: item.email,
            itemprice: item.price,
            itemurl: item.url,
            itemquantity: 1,
            phone: business?.phone,
            email: business?.email,
            username: business?.username,
            ownerurl: business?.url,
            status: business?.status
        }
        if (cartarray[0]?.itemquantity > 0) {
            const items = []
            cartarray.forEach(element => {//check if item exixts in cart
                if (element?.itemname == item.name) {
                    items.push(element)
                }
            });
            if (items.length > 0) {
                seterror("item already in cart")
            } else {
                onrefresh()
                cartarray.push(itemtopush)
                setsessioncart(cartarray)
                setnothing(!nothing)
            }
        } else {
            onrefresh()
            setcartarray([itemtopush])
            setsessioncart([itemtopush])
            setnothing(!nothing)
        }
    }

    //change item in view 
    const changeitem = (item) => {
        setitem(item)
    }



    //show login to go to my services
    const onsuccesslogin2 = () => {
        onrefresh()
        navigate('/nav/mybusinesses', {
            state: {
                message: "addbiz"
            }
        })
    }

    //got to my businesses
    const gotomybusinesses = () => {
        user ? navigate('/nav/mybusinesses', {
            state: {
                message: "addbiz"
            }
        }) : setshowloginpopup2(true)
    }



    return (
        <div>
            {loading && <Loadingspinner />}
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => seterror()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <div>
                <main className={housestyles.parent}>
                    <Modal
                        open={showloginpopup}
                        onClose={() => setshowloginpopup(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <SignIn onsuccesslogin={onsuccesslogin} />
                    </Modal>
                    <Modal
                        open={showloginpopup2}
                        onClose={() => setshowloginpopup2(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <SignIn onsuccesslogin={onsuccesslogin2} />
                    </Modal>
                    <Modal
                        open={sharepopup}
                        onClose={() => setsharepopup(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Sharepopup name={"Share Item link through"} link={url} />
                    </Modal>
                    <Modal
                        open={showimage}
                        onClose={() => setshowimage(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Container maxWidth="md">
                            <img src={defaulturl} style={{ margin: "0 auto" }} />
                        </Container>
                    </Modal>
                    <div className={housestyles.container}>

                        <div className={housestyles.topheader} style={{ paddingBottom: 20 }}>
                            <Universalheader refresh={nothing} />
                            <div className={housestyles.advertisediv}>
                                <FaStarOfLife color={primarycolor} size={15} />
                                <a onClick={() => gotomybusinesses()} style={{ cursor: "pointer" }}>List on Eazistey</a>
                            </div>
                            <div className={housestyles.housenamediv}>
                                <div onClick={() => setsharepopup(true)} style={{ position: "absolute", right: "6%", cursor: "pointer", fontSize: 12 }}>
                                    <FaShareSquare /><u>Share</u>
                                </div>
                                <div className={housestyles.housenamehead}>{business.bname?.toUpperCase()}</div>
                            </div>
                            <div className={housestyles.linksdiv}>
                                <Link to="/nav">
                                    <a>Home  /</a>
                                </Link>
                                <a onClick={() => navigate(-2)} style={{ cursor: "pointer" }}>Services  /</a>
                                <a onClick={() => navigate('/nav/viewsinglebusiness', { state: { email: item.email } })}>{business.bname}  /</a>
                                <a>{item.name}  /</a>
                            </div>
                            <div className={housestyles.bodydiv}>
                                <div></div>
                                <div className={housestyles.housedetailsdiv}>
                                    <div className="businesswrapflex">
                                        <div className="businessfirstdiv">
                                            <img onClick={() => {
                                                setshowimage(true)
                                                setdefaulturl(item.url)
                                            }} src={item.url} className="businessimage" /><br />
                                            <div className="businessdesc">{item?.description}</div>
                                            <div className="businessdesc"><b>{item?.price}</b> Ksh</div>
                                            <br /><br />
                                            <div>
                                                <button className={housestyles.callbutton} onClick={() => addtocart()}><FaShoppingCart /> ADD TO CART</button>
                                            </div>
                                        </div>
                                        <div className="businessseconddiv">
                                            <div className="wrapbusinesscatalogue">
                                                {Shuffle(catalogue)?.map((val, key) => {
                                                    return (
                                                        <div className="catalogueitemchild" key={key} onClick={() => changeitem(val)}>
                                                            <img src={val?.url ? val.url : require("./../../assets/common/image2.png")} />
                                                            <div>
                                                                <b>{val?.name}</b><br />
                                                                {val?.description.substring(0, 20)}<br />
                                                                <b>{val?.price}</b> Ksh<br />
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>

                                        </div>

                                    </div>



                                </div>
                            </div>
                            {isDesktop && business.type !== "remote" &&
                                <div className={housestyles.singelhousemap}>
                                    <div style={{ display: "flex" }}>
                                        <div className={housestyles.whereyou}>Where the business is</div>
                                        <a style={{ marginTop: 5, marginLeft: 20 }} href={`https://maps.eazistey.co.ke/?longitude=${catalogue[0]?.longitude}&latitude=${catalogue[0]?.latitude}`}>View directions</a>
                                    </div>
                                    <br /><br />
                                    {catalogue[0]?.longitude && <MapComponent longitude={catalogue[0]?.longitude} latitude={catalogue[0]?.latitude} />}
                                    <div style={{ fontWeight: "bold", marginTop: 10 }}>
                                        {catalogue[0]?.location},Chuka, Kenya
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </main>
            </div>

        </div>

    )
}

export default Viewsingleservice;